import React, { useState } from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useNavModel } from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { useAcctUnitModel } from "../acctUnitModel";
import { globalPrompt } from "@/components/YhMessage";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {
    const { selectedRowKeys, exportAcctUnit, updateEditFormVal, syncData } = useAcctUnitModel();
    const { addNav, findNav, switchNavState } = useNavModel(() => []);
    const [syncLoading, setSyncLoading] = useState<boolean>(false);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        let customerEditKey = "8-11-2";
        let isFindNav = findNav(customerEditKey);
        if (!isFindNav) {
            addNav(customerEditKey, { id: selectedRowKeys[0]?.code, mode: "edit" });
        } else {
            switchNavState(customerEditKey, { id: selectedRowKeys[0]?.code, mode: "edit" });
            updateEditFormVal(null);
        }
    }


    const action = <>
        <YhAuth resCode={ResourceAuthEnum.DATA_ACC_UNIT_AD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { addNav("8-11-1", { id: "", mode: "add" }) }}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_ACC_UNIT_ED}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_ACC_UNIT_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportAcctUnit()}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.DATA_APP_UNIT_SYNC}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={syncLoading}
                onClick={() => {
                    setSyncLoading(true);
                    syncData().then(res => setSyncLoading(false)).catch(err => setSyncLoading(false));
                }}
            >{syncLoading ? "同步中" : "同步"}</Button>
        </YhAuth>
    </>;

    return (
        <YhBox title="" action={action}>
            <DataTable />
        </YhBox>
    )
}